import { render, staticRenderFns } from "./BiTableView.vue?vue&type=template&id=363954dd&scoped=true&"
import script from "./BiTableView.vue?vue&type=script&lang=js&"
export * from "./BiTableView.vue?vue&type=script&lang=js&"
import style0 from "./BiTableView.vue?vue&type=style&index=0&id=363954dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363954dd",
  null
  
)

export default component.exports